<div class="col gap-24 w100">
    <div class="row gap-8 space-between align-center w100">
        <div class="row gap-16">
            <div class="col align-start">
                <rr-icon name="wind" color="nutral"></rr-icon>
            </div>
            <div class="row gap-8">
                <div class="name strong">{{ track.name }}</div>
                <div class="row gap-8">
                    <rr-badge tone="brand" *ngIf="track.industryTypeId">{{
                        track.industryTypeId | getIndustryNameById
                    }}</rr-badge>
                    <rr-badge
                        tone="success"
                        iconStart="user"
                        *ngIf="track.businessTypeId"
                        >{{
                            track.businessTypeId | getBusinessTypeNameById
                        }}</rr-badge
                    >
                    <rr-badge tone="warning" *ngIf="track.ideaTypeId">{{
                        track.ideaTypeId | getIdeaTypeNameById
                    }}</rr-badge>
                </div>
                <!-- <div class="tiny">Round ID: {{ track.roundId }}</div> -->
            </div>
        </div>

        <div class="gap-8 row align-center">
            <rr-btn size="Small" type="Link" (click)="deleteTrack()"
                >Delete</rr-btn
            >
            <rr-btn size="Small" type="Secondary" [routerLink]="continueLink"
                >Continue</rr-btn
            >
        </div>

        <!-- <app-drop-down
            [continueLink]="continueLink"
            [itemList]="menueList"
            [roundId]="track.roundId"
        ></app-drop-down> -->
    </div>

    <!-- <rr-divider class="spezmargin"></rr-divider>
  <div class="row space-between align-center spezmargin">
    <div class="row gap-4 align-center">
      <div
        class="stream col align-start justify-start gap-4"
        *ngFor="let stream of menueList"
      >
        <div class="row gap-4 align-center">
          <div class="dot" [ngClass]="stream.status"></div>
          <rr-progress
            class="progress"
            *ngIf="stream.itemName !== 'Ship'"
            [progress]="stream.progress || 0"
          ></rr-progress>
        </div>
        {{ stream.itemName }}
      </div>
      <rr-badge size="Small" iconStart="box" tone="brand" class="feedbackleft">
        {{ minimalFeedBacksForBMC - feedbackPinCounter }}
        {{
          minimalFeedBacksForBMC - feedbackPinCounter > 1
            ? "Feedbacks"
            : "Feedback"
        }}
        left until Ship
      </rr-badge>
    </div>
    <div class="row gap-8 align-center">
      <rr-btn
        type="Secondary"
        size="Small"
        [disabled]="feedbackPinCounter === 0 ? true : false"
        (click)="feedbackPinCounter !== 0 ? openFeedbackPinDashbord() : null"
        >{{ feedbackPinCounter }}
        {{ feedbackPinCounter <= 1 ? "Feedback" : "Feedbacks" }}</rr-btn
      >
      <rr-btn type="Secondary" size="Small" (click)="openKeyResultDashboard()"
        >Key Results</rr-btn
      >
    </div>
  </div> -->
</div>
